import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  showDescription?: boolean;
}

export default function ComicCard({ comic, showDescription = false }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-xl bg-background-100 transition-colors hover:bg-background-200"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}原版漫画封面`}
          title={`${comic.title} 原版漫画`}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <div className="absolute left-2 top-2 flex flex-col gap-1">
          {comic.hot && (
            <span className="flex items-center gap-1 rounded-full bg-primary-500 px-2 py-0.5 text-[10px] font-bold text-background-50 whitespace-nowrap">
              <i className="ri-fire-fill"></i> 热
            </span>
          )}
          {comic.status === '已完结' && (
            <span className="rounded-full bg-secondary-500/90 px-2 py-0.5 text-[10px] font-bold text-background-50 whitespace-nowrap">
              已完结
            </span>
          )}
        </div>
        <div className="absolute right-2 top-2 rounded-full bg-black/40 px-2 py-0.5 text-[10px] font-semibold text-foreground-950 backdrop-blur-sm whitespace-nowrap">
          <i className="ri-star-fill text-accent-500 mr-0.5"></i>
          {comic.rating}
        </div>
        <div className="absolute bottom-2 left-2 right-2">
          <span className="rounded-full bg-black/40 px-2 py-1 text-[11px] text-foreground-950 backdrop-blur-sm">
            <i className="ri-eye-line mr-1"></i>
            {comic.views} 人气
          </span>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h4 className="truncate text-sm font-bold text-foreground-950 group-hover:text-primary-500">
          {comic.title}
        </h4>
        <p className="mt-1 truncate text-xs text-foreground-500">
          <span className="text-foreground-700">{comic.author}</span> · {comic.latest}
        </p>
        {showDescription && (
          <p className="mt-2 line-clamp-2 text-xs leading-5 text-foreground-500">{comic.description}</p>
        )}
        <div className="mt-2 flex flex-wrap gap-1">
          {comic.tags.map((t) => (
            <span
              key={t}
              className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-[10px] text-secondary-900 whitespace-nowrap"
            >
              {t}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}